"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FeaturesContext_1 = require("./FeaturesContext");
var withoutFeature = function (Component, feature) {
    var WithoutFeatureWrappedComponent = function (props) {
        var featuresConfig = React.useContext(FeaturesContext_1.FeaturesContext);
        var shouldDisplay = featuresConfig.some(function (f) { return !f.isEnabled && f.name === feature; });
        return shouldDisplay ? React.createElement(Component, __assign({}, props)) : null;
    };
    WithoutFeatureWrappedComponent.displayName = "withoutFeature(" + Component.displayName + ")";
    return WithoutFeatureWrappedComponent;
};
exports.default = withoutFeature;
//# sourceMappingURL=withoutFeature.js.map